const status = "production";
// const status = "development";
export const localRequest = status === "development" ? "http://localhost:3009/" : "https://backend.cosmopolitan.edu.ng:7443/";
export const appHost = status === "development" ? "http://localhost:3006/" : window.location.origin;
export const UploadLink = status === "development" ? "https://doc.samtec.ng/index.php" : "https://doc.samtec.ng/index.php";
